import React from 'react';
import {Container,Col ,Row} from "react-bootstrap";
import {ClutchIconUpdated, GameIconUpdated, IndustriesIconUpdated} from "../../../app-constants";

function GameNumbers(props) {
    return (
        <section className="awrads_sec tekrevol_gray_bg p50">
            <Container>
                <Row>
                    <Col xs={12} md={4} lg={4}>
                       <div className="number_items">
                           {GameIconUpdated}
                           <div className="title_numbers">
                               20+
                               <span>Game Apps Developed</span>
                           </div>
                       </div>
                    </Col>
                    <Col xs={12} md={4} lg={4}>
                        <div className="number_items">
                            {ClutchIconUpdated}
                            <div className="title_numbers">
                                75+
                                <span>Clutch Reviews</span>
                            </div>
                        </div>
                    </Col>
                    <Col xs={12} md={4} lg={4}>
                        <div className="number_items">
                            {IndustriesIconUpdated}
                            <div className="title_numbers">
                                15+
                                <span>Industries Served</span>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
}

export default GameNumbers;